export default "__VITE_ASSET__ClC4aYeU__"